<template>
  <nav class="flex mb-2 xs:text-xs sm:text-xs md:text-md lg:text-base" :class="center?'justify-center':''">
    <button
        :class="tab.id===value?tabActiveClass:tabClass"
        v-for="(tab, index) in tabs" @click="$emit('input',tab.id)">
      {{ tab.title }}
    </button>
  </nav>
</template>

<script>
export default {
  name: "tabs",
  props: {
    value: {
      type: Number,
      default: () => 1
    },
    center: {
      type: Boolean,
      default: () => false
    },
    bgHeader: {
      type: String,
      default: () => 'bg-white'
    },
    tabActiveClass: {
      type: String,
      default: () => 'py-1 px-4 block hover:text-blue-500 focus:outline-none text-blue-500 border-b-2 border-blue-500 font-semibold'
    },
    tabClass: {
      type: String,
      default: () => 'text-gob py-1 px-4 block hover:text-primary focus:outline-none font-semibold'
    },
    tabs: {
      type: Array,
      default: () => [{id: 1, title: 'prueba'}]
    }
  },
}
</script>

<style scoped>

</style>
